/**
 * Master v5 Prompt 15 — one canonical written question textarea.
 */
export function QuestionField({ questionKey, label, value, onChange, testId }) {
  return (
    <div className="mb-4" data-testid={testId}>
      <label className="text-sm font-medium text-ink mb-1.5 block" htmlFor={`review-question-${questionKey}`}>
        {label}
      </label>
      <textarea
        id={`review-question-${questionKey}`}
        value={value || ""}
        onChange={(e) => onChange(questionKey, e.target.value)}
        rows={3}
        className="w-full border border-ink/15 rounded-lg px-3 py-2 text-sm text-ink bg-white/70 focus:outline-none focus:border-terracotta"
        data-testid={`${testId}-input`}
      />
    </div>
  );
}
